<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper home">
          <div class="title big">
            {{ $t("Exchange CS2 skins instantly — master the marketplace") }}
          </div>
          <div class="desc big">
            {{
              $t(
                "Instantly and securely trade CS2 skins on lootiqueskins. Explore the best offers, stay competitive, and boost your earnings with expert insights.",
              )
            }}
          </div>
          <div class="buttons">
            <div
              class="button w-220"
              v-if="$parent.isAuth"
              @click="setProductCategory('all')"
            >
              {{ $t("GET STARTED") }}
            </div>
            <div
              v-if="!$parent.isAuth"
              class="button w-220"
              @click="$parent.openSignIn()"
            >
              {{ $t("GET STARTED") }}
            </div>
          </div>
        </div>
      </div>

      <div class="section home-products-section">
        <div class="wrapper">
          <div class="top">
            <div class="title medium">
              {{ $t("Latest offers") }}
            </div>
            <button class="desc yellow" @click="setProductCategory('all')">
              {{ $t("See more") }}
            </button>
          </div>

          <SlickItem
            v-if="$parent.newArrivals.length"
            :currency="currency"
            :is-auth="$parent.isAuth"
            :categories="$parent.categoryOptions"
            :list="$parent.newArrivals"
            :add-to-cart-chosen-item="addToCartChosenItem"
            @setProductCategory="setProductCategory"
            @goToProduct="goToProduct"
            @addToCart="addToCart"
          />
        </div>
      </div>

      <div class="bg">
        <div class="section how-it-works-section">
          <div class="wrapper">
            <div class="title big">
              {{ $t("Trading CS2 skins? Make it easy") }}
            </div>

            <div class="list">
              <div class="item">
                <div class="title big micro yellow">
                  {{ $t("01") }}
                </div>
                <div class="desc big">
                  {{
                    $t(
                      "Explore CS2 skin prices in our marketplace to trade smarter and uncover rare finds.",
                    )
                  }}
                </div>
              </div>

              <div class="item">
                <div class="title big micro yellow">
                  {{ $t("02") }}
                </div>
                <div class="desc big">
                  {{
                    $t(
                      "Find affordable CS2 skins and easily check their wear levels — from Factory New to Minimal Wear.",
                    )
                  }}
                </div>
              </div>

              <div class="item">
                <div class="title big micro yellow">
                  {{ $t("03") }}
                </div>
                <div class="desc big">
                  {{
                    $t(
                      "Acquire CS2 skins below market price and resell when demand spikes. Don’t forget to factor in platform fees to optimize your returns.",
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section join-section">
          <div class="wrapper">
            <div class="left">
              <div class="title big">
                {{ $t("Trade smart. Rise legendary") }}
              </div>

              <div class="desc big yellow">
                {{
                  $t(
                    "See live CS2 trades unfold! Join the action, grab skins instantly, and cash out your items in clicks.",
                  )
                }}
              </div>

              <div class="buttons">
                <div class="button w-220 dark" @click="sellSkin">
                  {{ $t("SELL SKINS") }}
                </div>

                <div class="button w-220" @click="setProductCategory('all')">
                  {{ $t("BUY SKINS") }}
                </div>
              </div>
            </div>

            <div class="right">
              <img src="./../assets/case.webp" class="img" />
            </div>
          </div>
        </div>

        <div class="section faq-section">
          <div class="title big">
            {{ $t("FREQUENTLY ASKED QUESTIONS") }}
          </div>
          <div class="wrapper">
            <div class="faq-item" v-for="(item, index) in faq" :key="item.id">
              <button class="faq-header" @click="toggleFaq(index)">
                <div class="title small">{{ item.question }}</div>
                <div class="faq-icon">
                  {{ openFaq === index ? "−" : "+" }}
                </div>
              </button>

              <transition name="accordion">
                <div v-if="openFaq === index" class="faq-content">
                  <div class="desc" v-html="item.answer"></div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import SlickItem from "../components/SlickItem.vue";

export default {
  name: "Home",
  components: {
    SlickItem,
  },
  props: {
    addToCartChosenItem: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imgDomain: "",
      list: [],
      faq: [],
      openFaq: null,
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;

    this.$http
      .get(process.env.VUE_APP_API + "faq")
      .then((res) => {
        this.faq = res.data.payload;
      })
      .catch(() => {});
  },
  methods: {
    setProductCategory(category) {
      this.$emit("setProductCategory", category);
    },
    sellSkin() {
      if (this.$parent.isAuth) {
        this.$parent.openSellSkinModal();
      } else {
        this.$parent.openSignIn();
      }
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    addToCart(item, id) {
      this.$emit("addToCart", item, id);
    },
    toggleFaq(index) {
      this.openFaq = this.openFaq === index ? null : index;
    },
  },
};
</script>

<style scoped>
.title.big {
  margin-bottom: 24px;
  text-align: center;
}
.title.small {
  font-size: 24px;
}
.wrapper {
  max-width: 900px;
}
.faq-item + .faq-item {
  margin-top: 24px;
}

.faq-section {
  padding: 40px 16px;
}
.faq-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  color: inherit;
  text-align: left;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 14px 20px;
}

.faq-icon {
  font-size: 28px;
  line-height: 1;
  margin-left: 20px;
  flex-shrink: 0;
}

.faq-content {
  padding-top: 16px;
  overflow: hidden;
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.25s ease;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  opacity: 0;
  max-height: 0;
}

.accordion-enter-to,
.accordion-leave-from {
  opacity: 1;
  max-height: 1000px;
}
</style>
